// eslint-disable-next-line no-unused-vars
import React from 'react'
import PropTypes from 'prop-types'

import { Redirect, withRouter } from 'react-router-dom'

import UsernameBox from './UsernameBox'
import TemporaryPassword from './TemporaryPassword'
import PasswordBox from './PasswordBox'
import LoadingBox from './LoadingBox'
import EmailBox from './EmailBox'
import NumericPasswordBoxStep1 from './NumericPasswordBoxStep1'
import NumericPasswordBoxStep2 from './NumericPasswordBoxStep2'
import NumericPasswordBoxStep3 from './NumericPasswordBoxStep3'
import NumericPasswordBoxStep4 from './NumericPasswordBoxStep4'

import Helmet from 'react-helmet'
import TitleAnnouncer from '../TitleAnnouncer'
import yn from 'yn'

const LoginForm = ({
  loadingPage,
  forceOnboarding,
  cpf,
  usernamePolicy,
  getUserName,
  handleClearError,
  handleSendPassword,
  handleChange,
  handleContinue,
  handleBack,
  handleSubmit,
  handleContinueTemporary,
  handleContinueEmailConfirm,
  handleValidateConfirmEmail,
  isValidConfirmEmail,
  isUsernameSet,
  isTemporaryPassword,
  isEmailConfirm,
  hasNumericPassword,
  typeNumericPassword,
  confirmTypeNumericPassword,
  numericPasswordConfirmation,
  handleNumericPass,
  handleNumericPassConfirm,
  validateNumericPassword,
  validateNumericPasswordConfirm,
  backPasswordScreen,
  backStep1,
  backStep2,
  backStep3,
  numericPassword,
  cognitoAsfData,
  location: { search },
  ...rest
}) => {
  return loadingPage ? (
    <LoadingBox {...rest} />
  ) : (
    <form autoComplete='off' method='post' onSubmit={handleSubmit}>
      <input type='hidden' name='cognitoAsfData' value={cognitoAsfData} />
      {forceOnboarding && (
        <Redirect
          to={{
            pathname: '/recovery',
            state: {
              login: cpf
            },
            search: search
          }}
        />
      )}

      {!isUsernameSet ? (
        <>
          <Helmet>
            <title>{`${process.env.RAZZLE_TITLE} - Login`}</title>
          </Helmet>
          <TitleAnnouncer />
        </>
      ) : !(!isUsernameSet || !isTemporaryPassword) ? (
        <>
          <Helmet>
            <title>{`${process.env.RAZZLE_TITLE} - Senha provisória`}</title>
          </Helmet>
          <TitleAnnouncer />
        </>
      ) : !(!isUsernameSet || isTemporaryPassword) ? (
        <>
          <Helmet>
            <title>{`${process.env.RAZZLE_TITLE} - Senha`}</title>
          </Helmet>
          <TitleAnnouncer />
        </>
      ) : hasNumericPassword ? (
        <>
          <Helmet>
            <title>{`${process.env.RAZZLE_TITLE} - Senha númerica`}</title>
          </Helmet>
          <TitleAnnouncer />
        </>
      ) : typeNumericPassword ? (
        <>
          <Helmet>
            <title>{`${process.env.RAZZLE_TITLE} - Senha númerica`}</title>
          </Helmet>
          <TitleAnnouncer />
        </>
      ) : confirmTypeNumericPassword ? (
        <>
          <Helmet>
            <title>{`${process.env.RAZZLE_TITLE} - Confirmar senha provisória`}</title>
          </Helmet>
          <TitleAnnouncer />
        </>
      ) : numericPasswordConfirmation ? (
        <>
          <Helmet>
            <title>{`${process.env.RAZZLE_TITLE} - Senha númerica salva com sucesso!`}</title>
          </Helmet>
          <TitleAnnouncer />
        </>
      ) : (
        ''
      )}

      <UsernameBox
        usernamePolicy={usernamePolicy}
        handleChange={handleChange}
        handleContinue={handleContinue}
        isHidden={isUsernameSet}
        {...rest}
      />
      <TemporaryPassword
        handleSendPassword={handleSendPassword}
        handleBack={handleBack}
        handleChange={handleChange}
        handleContinueTemporary={handleContinueTemporary}
        getUserName={getUserName}
        isHidden={!isUsernameSet || !isTemporaryPassword}
        {...rest}
      />
      <PasswordBox
        handleBack={handleBack}
        handleChange={handleChange}
        handleClearError={handleClearError}
        isHidden={!isUsernameSet || isTemporaryPassword || isEmailConfirm}
        {...rest}
      />
      <EmailBox
        handleSendPassword={handleSendPassword}
        handleBack={handleBack}
        handleChange={handleChange}
        handleContinueEmailConfirm={handleContinueEmailConfirm}
        handleValidateConfirmEmail={handleValidateConfirmEmail}
        getUserName={getUserName}
        isValidConfirmEmail={isValidConfirmEmail}
        isHidden={!isUsernameSet || !isEmailConfirm}
        {...rest}
      />
      <NumericPasswordBoxStep1
        handleBack={backPasswordScreen}
        isHidden={!hasNumericPassword}
        numericPassword={numericPassword}
      />
      <NumericPasswordBoxStep2
        handleBack={backStep1}
        isHidden={!typeNumericPassword}
        handleNumericPass={handleNumericPass}
        validateNumericPassword={validateNumericPassword}
        {...rest}
      />
      <NumericPasswordBoxStep3
        handleBack={backStep2}
        isHidden={!confirmTypeNumericPassword}
        handleNumericPassConfirm={handleNumericPassConfirm}
        validateNumericPasswordConfirm={validateNumericPasswordConfirm}
        {...rest}
      />
      <NumericPasswordBoxStep4
        handleBack={backStep3}
        isHidden={!numericPasswordConfirmation}
        handleNumericPassConfirm={handleNumericPassConfirm}
        validateNumericPasswordConfirm={validateNumericPasswordConfirm}
        {...rest}
      />
    </form>
  )
}

LoginForm.propTypes = {
  usernamePolicy: PropTypes.string,
  getUserName: PropTypes.func.isRequired,
  handleSendPassword: PropTypes.func.isRequired,
  handleClearError: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleContinue: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func,
  isUsernameSet: PropTypes.bool,
  isEmailConfirm: PropTypes.bool,
  isValidConfirmEmail: PropTypes.bool,
  isTemporaryPassword: PropTypes.bool,
  hasNumericPassword: PropTypes.bool,
  typeNumericPassword: PropTypes.bool,
  confirmTypeNumericPassword: PropTypes.bool,
  numericPasswordConfirmation: PropTypes.bool,
  numericPassword: PropTypes.func,
  handleNumericPass: PropTypes.func,
  handleNumericPassConfirm: PropTypes.func,
  validateNumericPassword: PropTypes.func,
  validateNumericPasswordConfirm: PropTypes.func,
  backPasswordScreen: PropTypes.func,
  backStep1: PropTypes.func,
  backStep2: PropTypes.func,
  backStep3: PropTypes.func,
  name: PropTypes.string,
  username: PropTypes.string,
  cognitoAsfData: PropTypes.string,
  password: PropTypes.string,
  isLookingUpUsername: PropTypes.bool
}

export default withRouter(LoginForm)